import type { FiltersState } from './localState';

export const ACCOUNT_TRANSACTION_TABLE_TEST_ID = 'account-transaction-table';
export const ERROR_MESSAGE = 'An error occurred while accessing this account.';
export const ERROR_MESSAGE_TEST_ID = 'error-message';
export const CREATE_STATEMENT_BUTTON_TEST_ID = 'create-statement-button';
export const INTER_TRANSFER_BUTTON_TEST_ID = 'inter-transfer-button';
export const INTER_TRANSFER_FROM_SELECTOR_TEST_ID =
  'inter-transfer-from-selector';
export const INTER_TRANSFER_TO_SELECTOR_TEST_ID = 'inter-transfer-to-selector';
export const INTER_TRANSFER_AMOUNT_INPUT_TEST_ID =
  'inter-transfer-amount-input';
export const INTER_TRANSFER_END_TO_END_ID_INPUT_TEST_ID =
  'inter-transfer-end-to-end-input';
export const CREATE_STATEMENT_MODAL_TEST_ID = 'export-transactions-modal';
export const INTER_TRANSFER_BUTTON_PROCEED_TEST_ID = 'inter-transfer-proceed';
export const ACCOUNT_TRANSACTIONS_ENTRY_TYPE_FILTER_TEST_ID =
  'account-transactions-entry-type-filters';

export const ACCOUNT_TRANSACTION_ENTRY_TYPES: Array<
  FiltersState['entry_type']
> = [
  'collection',
  'collection_refund',
  'collection_fee',
  'collection_refund_fee',
  'refund_canceled',
  'refund_returned',
  'payout',
  'payout_fee',
  'payout_returned',
  'payout_cancelled',
  'incident_charges_fee',
  'monthly_fee',
  'minimum_processing_fee',
  'inter_account_transfer',
  'correction',
  'contract_trx_fee_adjustment',
  'contract_trx_fx_adjustment',
  'funding'
];
